const MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000;
const DAYS_IN_WEEK = 7;

const isDateLessThanWeekAgo = (date) => {
  const diff = new Date().getTime() - new Date(date).getTime();
  return diff / MILLISECONDS_IN_DAY < DAYS_IN_WEEK;
};

export default isDateLessThanWeekAgo;
